import {
  CarouselControls,
  CarouselNavigation,
  CarouselPagination,
  CarouselSlide,
  Carousel as DSCarousel,
} from '@cinch-labs/design-system'
import type { Vehicle } from '@cinch-nx/shared-types'
import cx from 'classnames'

import styles from './carousel.module.css'
import { VehicleCard } from '@cinch-nx/landing-ui-shared'
import {
  EventNames,
  TrackingEventTypes,
  useAnalytics,
} from '@cinch-nx/shared-analytics'

interface CarouselProps {
  carouselName: string
  vehicles: Vehicle[]
}

export const Carousel = ({ carouselName, vehicles }: CarouselProps) => {
  const { trackEvent } = useAnalytics()

  const navAriaLabels = {
    previous: 'Go to previous slide',
    next: 'Go to next slide',
  }

  if (!vehicles) {
    return <div className={styles.carouselLoading}>Loading...</div>
  }

  const vehiclesInStock = vehicles.slice(0, 6)

  return (
    <>
      <DSCarousel
        name={carouselName}
        swiperSettings={{
          slidesPerView: 1,
          spaceBetween: 16,
          breakpoints: {
            564: {
              slidesPerView: 1,
            },
            768: {
              slidesPerView: 2,
            },
            1024: {
              slidesPerView: 3,
            },
          },
        }}
        ariaLabel={`${carouselName}-carousel`}
      >
        {vehiclesInStock.map((vehicle) => (
          <CarouselSlide key={vehicle.vehicleId}>
            <VehicleCard
              vehicle={vehicle}
              id={'vehicles-in-stock-carousel'}
              isSaved={false}
              isPending={false}
              isAvailable={vehicle.isAvailable}
              onCardClick={() => {
                trackEvent({
                  eventName: `Cars in stock at cinch store`,
                  type: TrackingEventTypes.ADOBE,
                  data: {
                    event: {
                      name: EventNames.click,
                      category: 'Cars in stock at cinch store',
                      type: vehicle.site,
                      label: 'pdp card',
                      action: vehicle.vehicleId,
                    },
                  },
                })
              }}
            />
          </CarouselSlide>
        ))}
      </DSCarousel>
      <CarouselControls customClassNames={styles.controlsWrapper}>
        <CarouselPagination
          name={carouselName}
          className={cx(
            `${carouselName}-pagination`,
            styles.pagination,
            styles.customPagination,
          )}
          data-testid="ds-carousel-pagination"
          aria-hidden="true"
        />
        <CarouselNavigation
          name={carouselName}
          ariaLabels={navAriaLabels}
          ariaHidden={true}
          customClassNames={{
            prevButton: styles.prevButton,
            nextButton: styles.nextButton,
          }}
        />
      </CarouselControls>
    </>
  )
}
